export const backendLogger = (response) => {
  console.info(`Запрос:`, response, `Статус:`, response.status);
};
